import { render } from "./TypeFreePage.vue?vue&type=template&id=36b01859&ts=true"
import script from "./TypeFreePage.vue?vue&type=script&lang=ts"
export * from "./TypeFreePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__